import * as textConstants from '../text/constants';

export const { SIZES, APPEARANCES, TYPES, WEIGHTS } = textConstants;

export const TARGETS = {
  blank: '_blank',
  self: '_self',
};
